/* eslint-disable camelcase */
import { captureException } from '@sentry/nextjs';
import axios from 'axios';
import { MutationFunction, useMutation } from 'react-query';

export type UseRevivalType = {
  reviveId: string;
  deadWarriorIds: Array<string> | [];
  potionId: string;
  token: string | undefined;
};

const setRevival: MutationFunction<any, UseRevivalType> = async ({
  reviveId,
  deadWarriorIds,
  potionId,
  token,
}) => {
  const apiHost = process.env.NEXT_PUBLIC_API_HOST;
  let consumed_warrior_ids: number[] = [];
  if (deadWarriorIds.length) {
    consumed_warrior_ids = deadWarriorIds.map((str) => {
      return Number(str);
    });
  }
  const payload = {
    target_warrior_id: parseInt(reviveId, 10),
    potion_id: parseInt(potionId, 10),
    consumed_warrior_ids: consumed_warrior_ids,
  };
  try {
    const { data } = await axios({
      url: `${apiHost}/potions/use`,
      method: 'post',
      data: payload,
      headers: {
        'Content-type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });
    return data;
  } catch (err: any) {
    captureException(err);
    throw new Error(err?.message || 'Set revivial error');
  }
};

export const useSetRevival = () => {
  return useMutation(setRevival, {
    retry: 5,
  });
};
